// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1h4y0","title":"ClientReferral_title__c5AaE","itemText":"ClientReferral_itemText__1AXZi"};